import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { api, errText } from "./api";

export default function Login({ onLogin }) {
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError("");
    try { const { data } = await api.post("/auth/login", f); onLogin(data); }
    catch (err) { setError(errText(err)); }
    finally { setBusy(false); }
  };
  return (
    <div className="grid min-h-screen place-items-center bg-slate-950 px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl bg-white p-8 shadow-2xl">
        <span className="grid h-12 w-12 place-items-center rounded-full bg-slate-900"><Lock className="h-5 w-5 text-white" /></span>
        <h1 className="font-display mt-5 text-3xl font-black uppercase leading-none">Team sign in</h1>
        <p className="mt-2 text-sm text-slate-500">Good Home Improvement back office</p>
        <label className="mt-6 block text-sm font-semibold">Email
          <input type="email" required autoComplete="email" className="inp mt-1" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="admin-login-email" />
        </label>
        <label className="mt-4 block text-sm font-semibold">Password
          <input type="password" required autoComplete="current-password" className="inp mt-1" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="admin-login-password" />
        </label>
        {error && <p className="mt-4 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-slate-900 py-3 font-bold text-white disabled:opacity-60" data-testid="admin-login-submit">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
        <p className="mt-4 text-center text-xs text-slate-500">Forgot your password? Ask the owner to reset it.</p>
      </form>
    </div>
  );
}
